<template>
  <div class="mb-3">
    <b-form-group
      :label="$t('custom_forms.date_format')"
      label-for="dateFormat"
    >
    <div class="d-flex align-items-center">
      <vSelect
        id="dateFormat"
        v-model="format"
        :options="formatOptions"
        :clearable="false"
        label="value"
        class="w-50"
        @input="onInputChange"
      />
      <div class="ml-1" v-if="format">
        {{$t('video_tour.preview')}}: {{ format.label }}
      </div>
    </div>
    </b-form-group>

    <b-form-group
      :label="$t('custom_forms.show_empty')"
      label-for="show_empty"
    >
      <b-form-checkbox
        id="show_empty"
        v-model="showEmpty"
        :checked="false"
        switch
        @change="onInputChange"
      />
    </b-form-group>
  </div>
</template>

<script>
import {onMounted, ref} from '@vue/composition-api';
import vSelect from "vue-select";

export default {
  components: {
    vSelect
  },
  props: {
    data: {
      type: Object,
      default: () => ({ data: [] }),
    },
    config: Object,
  },
  setup(props, {emit, root}) {
    const defaultFormat = { value: "d/m/Y", label: "20/12/2025" }
    const format = ref(defaultFormat)
    const showEmpty = ref(false)
    const formatOptions = [
      defaultFormat,
      { value: "d/m/y", label: "20/12/25" },
      { value: "d-m-Y", label: "20-12-2025" },
      { value: "d-m-y", label: "20-12-25" },
    ]

    onMounted(async () => {
      format.value = props.data?.data?.[0]?.format || defaultFormat
      showEmpty.value = props.data?.data?.[0]?.showEmpty || false
    });

    function onInputChange() {
      const payload = {
        format: format.value,
        showEmpty: showEmpty.value,
      }

      emit("update:data", {
        data: [{ ...payload }] ,
      });
    }

    return {
      format,
      formatOptions,
      showEmpty,
      onInputChange,
    };
  },
};
</script>
<style lang="scss">
.v-select .vs__dropdown-toggle .vs__selected-options .vs__selected {
  text-transform: none !important;
}
</style>
